import { FreightItemTable} from "../FreightItemTable";
import { DataSource, Layout} from "@mcleod/components";

export abstract class AutogenLayoutQuoteFreightItemTable extends Layout {
	layoutFreightItemTable: FreightItemTable;
	sourceQuoteFreightGroupItem: DataSource;
}
